import React, { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import StatCrewTable from '../components/StatCrewTable';
import { fetchStatCrewData, StatCrewData } from '../services/StatCrewservices';
import { DashboardOutletContextValue } from '../types/dashboard';

function StatCrewPage() {
  const { username, selectedSport } = useOutletContext<DashboardOutletContextValue>();
  const [statCrewData, setStatCrewData] = useState<StatCrewData | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isActive = true;

    const loadStatCrewData = async () => {
      if (!username) {
        setError('Username is missing. Please login again.');
        setStatCrewData(null);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const data = await fetchStatCrewData({
          username,
          selectedSport,
        });

        if (isActive) {
          setStatCrewData(data);
        }
      } catch (fetchError) {
        console.error('Error fetching StatCrew data:', fetchError);

        if (isActive) {
          setStatCrewData(null);
          setError('Unable to fetch StatCrew data.');
        }
      } finally {
        if (isActive) {
          setIsLoading(false);
        }
      }
    };

    void loadStatCrewData();

    return () => {
      isActive = false;
    };
  }, [selectedSport, username]);

  return (
    <StatCrewTable
      data={statCrewData}
      isLoading={isLoading}
      error={error}
      username={username}
      selectedSport={selectedSport}
    />
  );
}

export default StatCrewPage;
